'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _radio = require('../components/radio');
var _radio2 = _interopRequireDefault(_radio);
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
VehicleKept.propTypes = {
  options: _propTypes.array
};
VehicleKept.defaultProps = {
  options: []
};
function VehicleKept(props) {
  return _react2.default.createElement(_radio2.default, {
    name: 'keptOvernight',
    label: 'Where is the car kept overnight?',
    options: props.options
  });
}
exports.default = VehicleKept;